export default __webpack_public_path__ + "static/media/recruitweb.dbfd4e46.svg";